function isOpen(hash) {
    return window.location.hash.split('#').includes(hash);
}

export default isOpen;
